<template>
  <div class="verification-form-common-risk app-key-value__list">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-bdd-product-service-risk-factors.title" | globalize }}
      </h3>

      <template v-for="(value,key) in form">
        <verification-form-question
          v-model="form[key]"
          :key="key"
          :input="former.setAttr(`productServiceRiskFactors.${key}`, value)"
          :question-message="
            `verification-bdd-product-service-risk-factors.${key}` | globalize"
          :error-message="getFieldErrorMessage(`form.${key}`)"
          :disabled="isDisabled"
        />
      </template>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from '../../VerificationCDDForm/components/VerificationFormQuestion'

import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { required } from '@validators'
import _isEmpty from 'lodash/isEmpty'

import FormMixin from '@/vue/mixins/form.mixin'

export default {
  name: 'product-service-risk-factors',
  components: { VerificationFormQuestion },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: VerificationBDDFormer,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.productServiceRiskFactors.qus01,
        qus02: this.former.attrs.productServiceRiskFactors.qus02,
        qus03: this.former.attrs.productServiceRiskFactors.qus03,
        qus04: this.former.attrs.productServiceRiskFactors.qus04,
        qus05: this.former.attrs.productServiceRiskFactors.qus05,
        qus06: this.former.attrs.productServiceRiskFactors.qus06,
      },
      isEmpty: _isEmpty,
    }
  },
  validations () {
    let form = {}
    Object.keys(this.form).forEach(key => { form[key] = { required } })

    return { form }
  },

  methods: {
    isArray (value) {
      return Array.isArray(value)
    },
    formatData (value) {
      if (!value) {
        return '-'
      } else if (this.isArray(value)) {
        return value.join(', ')
      } else {
        return value
      }
    },
  },
}
</script>
